<template>
  <b-table
    :data="results"
    paginated
    backend-pagination
    @page-change="onPageChange"
    :total="total"
    :per-page="pageSize"
    striped
  >
    <template slot-scope="props">
      <b-table-column field="name" label="Name">{{
        props.row.name
      }}</b-table-column>
      <b-table-column field="code" label="Code"
        ><b-tag size="is-medium" class="is-italic"
          >{{ props.row.code }}
        </b-tag></b-table-column
      >
      <b-table-column field="isUnique" label="Einmalig" centered>
        <span v-if="props.row.isUnique">
          <i class="fas fa-check"></i>
          <small v-if="props.row.claimed"
            >(Eingelöst {{ props.row.claimed | formatDate }})</small
          >
        </span>
        <span v-if="!props.row.isUnique">
          <i class="fas fa-times"></i>
        </span>
      </b-table-column>
      <b-table-column field="constraints" label="Einschränkungen">
        <ul>
          <li v-for="c in props.row.constraints" :key="c.id">
            <span v-if="c.field == 0">Promotion</span>
            <span v-if="c.field == 1">Land</span>
            <span v-if="c.field == 2">Thema</span>
            <span v-if="c.field == 3">Mandant</span>
            <span v-if="c.field == 4">Angebot</span>
            &nbsp;
            <span v-if="c.comparer == 0">ist</span>
            <span v-if="c.comparer == 1">ist nicht</span>
            &nbsp;
            <span v-if="c.field != 4">{{ c.value }}</span>
            <span v-if="c.field == 4"><OfferIdTooltip :id="c.value"/></span>
          </li>
        </ul>
      </b-table-column>
      <b-table-column field="type" label="Art" centered>
        <span v-if="props.row.amount">
          <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-euro-sign fa-stack-1x fa-inverse"></i>
          </span>
        </span>
        <span v-if="props.row.percentage">
          <span class="fa-stack">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-percentage fa-stack-1x fa-inverse"></i>
          </span>
        </span>
      </b-table-column>

      <b-table-column field="description" label="Reduktion">{{
        props.row.description
      }}</b-table-column>

      <b-table-column field="validFrom" label="Gültig von" centered>{{
        props.row.validFrom | formatDate
      }}</b-table-column>
      <b-table-column field="validTo" label="Gültig bis" centered>{{
        props.row.validTo | formatDate
      }}</b-table-column>

      <b-table-column centered>
        <b-button
          size="is-small"
          icon-left="trash"
          type="is-danger"
          @click="deleteReduction(props.row)"
          >Entfernen</b-button
        >
      </b-table-column>
    </template>
  </b-table>
</template>

<script>
import OfferIdTooltip from '@/components/OfferIdTooltip'
export default {
  name: 'ReductionTable',
  props: {
    results: Array,
    page: Number,
    pageSize: Number,
    total: Number,
  },
  components: {OfferIdTooltip},
  methods: {
    deleteReduction(item) {
      this.$buefy.dialog.confirm({
        title: `Promotioncode '${item.code}' entfernen?`,
        message:
          'Sind Sie <strong>sicher</strong>, dass Sie diesen Promotioncode entfernen möchten? Die Aktion kann nicht rückgängig gemacht werden!',
        confirmText: 'Promotioncode löschen',
        cancelText: 'Abbrechen',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.$emit('request-delete', item),
      })
    },
    onPageChange(p) {
      this.$emit('request-page', p)
    },
  },
}
</script>

<style lang="scss">
.fa-stack {
  font-size: 0.75rem;
}
</style>
